// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2714%27 height=%2710%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1.75 5.75l3 3 7.5-7.5%27 stroke=%27%23fff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#focus--fbXhf:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  #focus--fbXhf:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  #focus--fbXhf:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
#focus-within--UF8MG:focus-within {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: 0px;
  border-radius: 0.25rem;
}
.checkboxWrapper--_4o9Z {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
}
.checkboxWrapper--_4o9Z .checkboxCopy--hUrRA {
  display: flex;
  flex-direction: column;
}
.checkboxWrapper--_4o9Z .checkboxCopyColor--KkmBL {
  color: #5A6F99;
}
.checkboxWrapper--_4o9Z span {
  color: #2D3748;
}
.checkbox--GnFl_ {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: block;
  width: 19px !important;
  height: 18px !important;
  margin-right: 0.5rem;
  background-color: #FFF;
  border-radius: 4px;
  border: 2px solid #6B83A8;
  cursor: pointer;
  flex-shrink: 0;
}
.checkbox--GnFl_:checked {
  background-color: #001550;
  background-size: 100%;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}
.checkbox--GnFl_:hover {
  border-color: #193DA1;
}
.checkbox--GnFl_:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  .checkbox--GnFl_:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  .checkbox--GnFl_:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
.checkbox--GnFl_:active {
  border-color: #001550;
  background-color: #001550;
  outline: none;
}
.checkbox--GnFl_:checked:active,
.checkbox--GnFl_:checked:hover,
.checkbox--GnFl_:checked:focus {
  background-color: #001550;
}
.checkbox--GnFl_.error--R4esb {
  border: 3px solid #DF0000 !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@boclips-ui/styles/src/focus.less","webpack://./src/components/registrationPageCheckbox/style.module.less"],"names":[],"mappings":"AAIE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACHJ;ADUE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECRJ;EDUE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECRJ;AACF;ADaE;EACE,sDAAA;EACA,mBAAA;EACA,sBAAA;ACXJ;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAoBF;AAxBA;EAOI,aAAA;EACA,sBAAA;AAoBJ;AA5BA;EAYI,cAAA;AAmBJ;AA/BA;EAgBI,cAAA;AAkBJ;AAdA;EACE,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAgBF;AAdE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yDAAA;EACA,4BAAA;AAgBJ;AAbE;EACE,qBAAA;AAeJ;ADxDE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;AC0DJ;ADnDE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECqDJ;EDnDE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECqDJ;AACF;AA3BE;EACE,qBAAA;EACA,yBAAA;EACA,aAAA;AA6BJ;AA1BE;;;EAGE,yBAAA;AA4BJ;AAzBE;EACE,oCAAA;AA2BJ","sourcesContent":["@import './vars';\n\n#focus {\n  // For any browser that doesn't focus-visible (Safari)\n  &:focus {\n    outline: @focus-outline;\n    outline-offset: @focus-outline-offset;\n    border-radius: .25rem;\n  }\n\n  // For browsers that do support focus-visible:\n  // - turn off focus styles\n  // - apply styles only to focus-visible\n  // https://www.tpgi.com/focus-visible-and-backwards-compatibility/\n  @supports selector(:focus-visible) {\n    &:focus {\n      outline: none;\n      outline-offset: 0;\n      border-radius: .25rem;\n    }\n    &:focus-visible {\n      outline: @focus-outline;\n      outline-offset: @focus-outline-offset;\n      border-radius: .25rem;\n    }\n  }\n}\n\n#focus-within{\n  &:focus-within {\n    outline: @focus-outline;\n    outline-offset: 0px;\n    border-radius: .25rem;\n  }\n}\n","@import \"~@boclips-ui/styles/src/colors\";\n@import \"~@boclips-ui/styles/src/focus\";\n\n.checkboxWrapper {\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n  align-items: center;\n\n  .checkboxCopy {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .checkboxCopyColor {\n    color: @gray-600;\n  }\n\n  span {\n    color: @gray-800;\n  }\n}\n\n.checkbox {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  display: block;\n  width: 19px !important;\n  height: 18px !important;\n  margin-right: 0.5rem;\n  background-color: @white;\n  border-radius: 4px;\n  border: 2px solid @gray-500;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:checked {\n    background-color: @blue-900;\n    background-size: 100%;\n    background-position: center;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='14' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.75 5.75l3 3 7.5-7.5' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n  }\n\n  &:hover {\n    border-color: @blue-700;\n  }\n\n  #focus;\n\n  &:active {\n    border-color: @blue-900;\n    background-color: @blue-900;\n    outline: none;\n  }\n\n  &:checked:active,\n  &:checked:hover,\n  &:checked:focus {\n    background-color: @blue-900;\n  }\n\n  &.error {\n    border: 3px solid @error!important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"focus": `focus--fbXhf`,
	"focus-within": `focus-within--UF8MG`,
	"checkboxWrapper": `checkboxWrapper--_4o9Z`,
	"checkboxCopy": `checkboxCopy--hUrRA`,
	"checkboxCopyColor": `checkboxCopyColor--KkmBL`,
	"checkbox": `checkbox--GnFl_`,
	"error": `error--R4esb`
};
export default ___CSS_LOADER_EXPORT___;
